import * as React from 'react'

import { NextPage, withErrorPage, withScridId } from '@grandvisionhq/next'
import { Hooks, Types } from '@grandvisionhq/stores-v2'
import { compose } from '@grandvisionhq/utils'
import { InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/store-group'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../../components/error-props'

const StoreGroupPage: NextPage<Props, InitialProps> = ({ ...props }) => {
  const { useDefaultStoreSearchFilters } = Hooks
  const { openNow, openOnTheWeekend, wheelChairAccessible } = useDefaultStoreSearchFilters()
  const storeSearchFilters: Types.StoreSearchFilterMap | undefined = React.useMemo(() => {
    return !openNow || !openOnTheWeekend || !wheelChairAccessible
      ? undefined
      : { openNow, openOnTheWeekend, wheelChairAccessible }
  }, [openNow, openOnTheWeekend, wheelChairAccessible])

  return <Page {...props} storeSearchFilters={storeSearchFilters} />
}

StoreGroupPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout(),
  withScridId()
)(StoreGroupPage)
